import { render, staticRenderFns } from "./RegistrationForms.vue?vue&type=template&id=303c644b"
import script from "./RegistrationForms.vue?vue&type=script&lang=js"
export * from "./RegistrationForms.vue?vue&type=script&lang=js"
import style0 from "./RegistrationForms.vue?vue&type=style&index=0&id=303c644b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports